(() => {
  if (window.merooHeroFilmReady) return;
  window.merooHeroFilmReady = true;

  const initialise = (root) => {
    const video = root.querySelector('[data-meroo-hero-film]');
    if (!video || video.dataset.initialised) return;
    video.dataset.initialised = 'true';
    const button = root.querySelector('[data-meroo-film-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    video.muted = true;
    video.defaultMuted = true;
    let visible = !('IntersectionObserver' in window);
    let manualPlay = null;
    let pending = false;
    let disposed = false;
    let observer;
    let headerObserver;

    const sync = () => {
      if (!button) return;
      button.setAttribute('aria-label', video.paused ? 'Play hero film' : 'Pause hero film');
      button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
    };
    const shouldPlay = () => !disposed && visible && !document.hidden &&
      (manualPlay ?? (!reduceMotion.matches && !connection?.saveData));
    const update = () => {
      video.autoplay = shouldPlay();
      if (!shouldPlay()) {
        video.pause();
        return;
      }
      if (!video.paused || pending) return;
      pending = true;
      Promise.resolve(video.play()).then(() => {
        if (!shouldPlay()) video.pause();
      }).catch(sync).finally(() => { pending = false; });
    };
    const toggle = () => {
      manualPlay = video.paused;
      visible = true;
      update();
    };
    const onError = () => { if (button) button.hidden = true; };
    if (button) {
      button.hidden = false;
      button.addEventListener('click', toggle);
    }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('error', onError);
    reduceMotion.addEventListener('change', update);
    connection?.addEventListener?.('change', update);
    document.addEventListener('visibilitychange', update);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
        update();
      }, { threshold: 0.1 });
      observer.observe(video);
    }
    const header = document.querySelector('.section-header');
    if (header && 'ResizeObserver' in window) {
      const sizeHeader = () => root.style.setProperty('--meroo-hero-header-height', `${header.getBoundingClientRect().height}px`);
      headerObserver = new ResizeObserver(sizeHeader);
      headerObserver.observe(header);
      sizeHeader();
    }
    // Start the visible hero immediately; below-the-fold images must not delay it.
    update();

    const dispose = (event) => {
      if (!event.target.contains(root)) return;
      disposed = true;
      video.autoplay = false;
      video.pause();
      observer?.disconnect();
      headerObserver?.disconnect();
      document.removeEventListener('visibilitychange', update);
      document.removeEventListener('shopify:section:unload', dispose);
      reduceMotion.removeEventListener('change', update);
      connection?.removeEventListener?.('change', update);
      button?.removeEventListener('click', toggle);
      video.removeEventListener('play', sync);
      video.removeEventListener('pause', sync);
      video.removeEventListener('error', onError);
      delete video.dataset.initialised;
    };
    document.addEventListener('shopify:section:unload', dispose);
  };
  document.querySelectorAll('.meroo-brand-hero').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.meroo-brand-hero').forEach(initialise));
})();
